import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HelpPageComponent } from './help-page/help-page.component';



const routes: Routes = [
  {
    path: '',
    component: HelpPageComponent
  },
  {
    path: 'help',
    component: HelpPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InfoRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/modules/help/components/info-routing.module.ts